import { type PropsWithChildren } from 'react';

import type { SparklineThresholdIndicatorProps } from '../types/sparkline-thresholds-props.js';

export const ThresholdIndicator = (
  props: PropsWithChildren<SparklineThresholdIndicatorProps>,
) => null;

ThresholdIndicator['displayName'] = 'Sparkline.ThresholdIndicator';
